export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAFCAAAAACRY8hiAAAAAnRSTlMAAHaTzTgAAAAPSURBVHgBY9zNQBaghT4At2sCNUVX4WMAAAAASUVORK5CYII="